module.exports = {
  footerText: '© 2022 IMPACT Labs Inc.',
}
